import { useEffect, useState } from "react";
import RightArrow from "../../../../../images/ArrowRight.svg";
import { PageFor } from "../../../../../utils/Enum.types";
import { CustomModal, toStandardDate } from "../../../../../utils/UtilFunctions";
import
{
  AddModalStyles,
  HistoryModalStyles,
  ViewItemsModalStyles,
  ViewModalStyles,
  ViewTicketModalStyles
} from "../../../../../styles/CustomModalStyles";
import { Button } from "../../../../../stories/Button/Button";
import { GetMomsForProject } from "../queries/query";
import { GetMomsForProjectResult, GetMomsForProjectVars } from "../queries/types";
import { useLazyQuery } from "@apollo/client";
import useUrlParams from "../../../../../customHooks/useUrlParams";
import useLoggedInUserDetails from "../../../../../customHooks/useLoggedInUserDetails";
import Close from "../../../../../images/Close.svg"
import MeetingDetailsLeft from "./PreviousMeetingDetails";
import PreviousMeetingDetails from "./PreviousMeetingDetails";

const History = () =>
{
  const [ presentDetails, setPresentDetails ] = useState( false );
  const { customer_id, projectID, } = useUrlParams();

  const [ momId, setMomId ] = useState( 0 );

  const [ GetMomDetails, { data } ] = useLazyQuery<GetMomsForProjectResult, GetMomsForProjectVars>(
    GetMomsForProject
  );
  const { user_details } = useLoggedInUserDetails();
  useEffect( () =>
  {
    if ( customer_id && projectID && user_details.id )
      GetMomDetails( {
        variables: {
          customerID: customer_id,
          empID: user_details.id,
          projectID: projectID,
        },
      } );
  }, [ GetMomDetails, customer_id, user_details.id, projectID
  ] );


  return (
    <div className="meeting-details-history">
      <div className="meeting-details-history__header">
        <ul>
          <li>
            <div className="meeting-details-history__header--grid">
              <span>Sl</span>
              <span>Date</span>
            </div>
            <div>
              <span>Completed</span>
            </div>
            <div className="meeting-details-history__header--r-grid">
              <span>Attendance</span>
              <span>Action</span>
            </div>
          </li>
        </ul>
      </div>
      <div className="meeting-details-history__data">
        <ul className="">
          {data ? data.GetMomsForProject.map( ( res, index ) =>
          {
            return (
              <li key={index}>
                <div className="meeting-details-history__header--grid">
                  <span>{index + 1}</span>
                  <span className="meeting-details-history__data--date">
                    {toStandardDate( res.meetingDate )}
                  </span>
                </div>
                <div>
                  <span className="font-green">{res.vendorRespCount} /</span>
                  <span className="font-red">{res.pmuCount}</span>
                </div>
                <div className="meeting-details-history__header--r-grid">
                  <span
                    className={
                      res.attCount
                        ? "font-green"
                        : "font-red"
                    }
                  >
                    {res.attCount
                      ? <>{res.attCount} attendee{res.attCount > 1 ? 's' : ''}</>
                      : <>No attendees</>}
                  </span>
                  <img
                    src={RightArrow}
                    alt=""
                    onClick={() =>
                    {
                      // if (res.status === AttendanceTypes.Absent) {
                      //   return setAbsentDetails(!absentDetails);
                      // } else return

                      setMomId( res.momID );
                      setPresentDetails( !presentDetails );
                    }}
                  />
                </div>
              </li>
            );
          } ) : null}
        </ul>
      </div>{" "}

      <CustomModal
        style={HistoryModalStyles}
        isOpen={presentDetails}
        onRequestClose={() => { }}
        contentComponent={
          <>
            <div className="meeting-details-history__previous">
              <PreviousMeetingDetails pageType={PageFor.MODAL} momID={momId} latest={true} setPresentDetails={setPresentDetails} />
              <Button
                mode="cancel"
                onClick={() => setPresentDetails( !presentDetails )}
              />
            </div>

          </>
        }
      />
    </div>
  );
};

export default History;
